module.exports = __webpack_public_path__ + "img/sumdes-promotions.872b3a30.png";